export class KompetenceEvalueringsskemaRequestModel {
    constructor(kompetenceId: string, laegekompetenceId: string) {
        this.kompetenceId = kompetenceId;
        this.laegekompetenceId = laegekompetenceId;
    }
    kompetenceId: string;
    laegekompetenceId: string;
}
